import React, { useEffect } from "react";
import BlurryImage from "../Components/BlurryImage.component";
import { Helmet } from "react-helmet-async";

import "../styles/content.style.scss";
import "../styles/about.style.scss";

function About() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>A propos | GI</title>
        <link
          rel="canonical"
          href="https://www.generalite-informatique.vercel.app/about"
        />
        <meta property="og:title" content="Contact GI" />
      </Helmet>
      <div className="App top-ctn">
        <div className="ctn-content">
          <h1 className="top t-center head-title">A propos</h1>
          <div className="tcard-ctn">
            <p>
              La GI (Généralité informatique) est une entreprise spécialisée
              dans les domaines :{" "}
              <b>ventes et installation des caméras vidéosurveillance</b> aussi
              dans l' <b>installation et maintenance réseau informatique</b>{" "}
              ainsi que la <b>maintenance des equipements informatique</b> et la{" "}
              <b>vente des fournitures de bureau</b>.
            </p>
          </div>
          <div className="img-ctn">
            <BlurryImage
              className="cover"
              imageUrl={"./Images/Sliders/slide-2.jpg"}
            />
          </div>
          <h1 className="top t-center head-title">Nos Missions</h1>
          <div className="tcard-ctn">
            <p>
              la sécurité et la surveillance, offrant une gamme complète de
              produits et de services. Elle vend une variété d'équipements de
              surveillance tels que des caméras, ainsi que des logiciels de
              gestion de données pour stocker et gérer efficacement les
              informations collectées.
            </p>
          </div>
          <div className="img-ctn">
            <BlurryImage
              className="cover"
              imageUrl={"./Images/Sliders/slide-3.jpg"}
            />
          </div>
          <h1 className="top t-center head-title">Notre Equipe</h1>
          <p className="t-center">
            Rencontrez les gens derriere ce service de reference
          </p>
          <div className="list-author">
            <div className="card-user">
              <div className="ctn-user-img">
                <BlurryImage
                  className="cover"
                  imageUrl={"./Images/user/profil.jpg"}
                />
              </div>
              <div className="desc">
                <h2>Mahamat Pele</h2>
                <span className="hightlight-title role">PDG GI</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
